export default "__VITE_ASSET__B8mqJk7y__"